import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { CaseManagementService } from 'src/app/core/services/v2/case-management.service';
import { PracticeService } from 'src/app/core/services/v2/practice.service';
import { WindowLoaderService } from 'src/app/shared/components/window-loader/window-loader.service';
import { Case } from '../../models/casehistory';
import { CaseManagerChange } from '../../models/changeCaseManager';

@Component({
  selector: 'assigncasemanager',
  templateUrl: './assigncasemanager.component.html',
  styleUrls: ['./assigncasemanager.component.scss']
})
export class AssigncasemanagerComponent implements OnInit {
  @Input() caseModel: Case;
  @Output() toggleEvent = new EventEmitter();
  selectedCMId:number;
  physicians:any;
  constructor(
    public dialog: MatDialog,
    private practiceService:PracticeService,
    private loaderService: WindowLoaderService,
  
    private caseManagementService: CaseManagementService,
  ) { }

  ngOnInit() {
    this.loadCasePractices();
  }

  loadCasePractices(){
    this.loaderService.show();
    this.practiceService.getAllHealthSystemAndPractitionersByUserID(this.caseModel.authorUserId).subscribe(
      (p) => { 
        this.physicians=p.physician;
        this.loaderService.hide();
      },
      (error) => { this.loaderService.hide();console.error(error); }
    );
  }
  openDialog(selectedCMId): void {
    this.selectedCMId=selectedCMId;
    const dialogRef = this.dialog.open(WarningDialog, {
      width: '350px',
      //data: {name: this.name, animal: this.animal}
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
      if(result){
        this.onCaseManagerChange(this.selectedCMId);
      }else{
      //this.animal = result;
      this.toggleEvent.emit();
      }
    });
  }
  

  onCaseManagerChange(cmId: number){
    this.loaderService.show();
    let changeCaseManager=new CaseManagerChange();
    changeCaseManager.caseId=this.caseModel.id;
    changeCaseManager.caseManagerId=cmId;
    this.caseManagementService.changeCaseManager(changeCaseManager).subscribe(
      (res) => {
        
    
        this.loaderService.hide();
        this.toggleEvent.emit();
      },
      (error) => {
        console.error(error);
        this.loaderService.hide();
      },
      () => {
        this.loaderService.hide();
      }
    );
      }
}
@Component({
  selector: 'waringdialog',
  templateUrl: 'casemanagerchangewarningdialog.html',
})
export class WarningDialog {

  constructor(
    public dialogRef: MatDialogRef<WarningDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any) {}

    onYesClick(): void {
    this.dialogRef.close(true);
  }

}

